// export const runtime = 'experimental-edge';

import GameCardCarousel from '@/components/features/common/GameCardCarousel';
import CatchError from '@/components/system/CacthError';
import { gameListSelector } from '@/state/globalSettings';
import { Box } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

const ProvidersPage = () => {
  const { list } = useAtomValue(gameListSelector);
  const {
    query: { provider },
  } = useRouter();
  const gameList = useMemo(() => {
    try {
      const providerName = provider[provider.length - 1]
        .replace(/\s+/g, '')
        .toLocaleLowerCase();
      return list.filter((game) => {
        return game.product
          .toLocaleLowerCase()
          .replace(/\s+/g, '')
          .startsWith(providerName);
      });
    } catch (e) {
      return [];
    }
  }, [provider, list]);

  return (
    <Box>
      {gameList.length ? (
        <GameCardCarousel games={gameList} />
      ) : (
        <Box>
          <h1>No game is available</h1>
        </Box>
      )}
    </Box>
  );
};

export default CatchError(ProvidersPage);
